import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import Loader from "../../common/loader/Loader";
import "./BookList.css";

function BookList(props) {
  const [books, setBooks] = useState();
  const [redirect, setRedirect] = useState(null);
  const [renderShowsTotal, setrenderShowsTotal] = useState(true);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [selectedBook, setSelectedBook] = useState(0);
  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    setSelectedBook(props.initialValue);
  }, [props.initialValue]);

  const handleIdBookChange = (event, newValue) => {
    props.setIdBookOnMem(event.target.value, props.row);

    setSelectedBook(newValue.props.value);
  };
  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 230,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },

    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  /*const displayForm = async (data, index) => {
    console.log('Data', data);
    console.log('Index', index);
    let book = books[index];
    console.log('book', book);
    await setRecord();
    await setRecord(book);
    setshowInfo(false);
  };*/

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    //Profile Props',props )
    const url = process.env.REACT_APP_API2_URL + "/Player/GetBooks";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setBooks(data);
        setIsLoading(false);
      });
  }, []);

  function onAfterDeleteRow(rowKeys) {
    let deleteRequest = {
      Idbook: rowKeys,
      IdUser: userInfo.IdUser,
    };

    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/book/book_Delete",
      data: deleteRequest,
    }).then((response) => {});
    alert("The rowkey you drop: " + rowKeys);
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }

  function selectedValues(row) {
    setRedirect(row);
  }

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 28, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "<", // Previous page button text
    nextPage: ">", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: renderShowsTotal, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    withFirstAndLast: false, // > Hide the going to First and Last page button
    //expandRowBgColor: 'rgb(196, 222, 222)',
    // afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    //handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
  };

  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    //afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };

  function onBeforeSaveCell() {
    // You can do any validation on here for editing value,
    // return false for reject the editing
    return true;
  }
  const printInputList = () => {
    return (
      <div>
        <FormControl
          className={`${classes.formControl} w-full`}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Book
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedBook}
            onChange={handleIdBookChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            {books &&
              books.map((row) => (
                <MenuItem value={row.idBook} key={row.idBook}>
                  {row.description}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  const printList = () => {
    return (
      <div id="main-div profile-list" class="profile-list">
        <Paper className={classes.root}>
          <h2>Line Types</h2>

          {isLoading ? <Loader></Loader> : ""}
          <Table className={classes.table} aria-label="simple table">
            <TableBody className={showInfo ? "show-table" : "hide-table"}>
              {books && (
                <div>
                  <BootstrapTable
                    pagination={true}
                    options={options}
                    cellEdit={cellEditProp} //DBClick daba problemas con el Expand
                    version="4"
                    data={books}
                    // deleteRow={true}
                    hover
                  >
                    <TableHeaderColumn
                      isKey={true}
                      filter={{ type: "TextFilter", delay: 1000 }}
                      dataField="description"
                    >
                      Description
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              )}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  };

  if (redirect) {
    let pushURL = "/lineType/" + redirect.IdBook;
    props.setLineType(redirect);
    printList();
    setRedirect(null);
    return (
      <div>
        <Redirect
          to={{
            pathname: pushURL,
          }}
        />

        {}
      </div>
    );

    //history.push(pushURL);
  }

  if (props.isInput) {
    return printInputList();
  } else {
    return printList();
  }
}

export default BookList;
